/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { withRouterPropTypes } from '../shapes';

const LogoutLink = ({ match, location, history, staticContext, next, ...props }) => {
  if (!next) {
    next = location.pathname + location.search;
  }
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a href={`/auth/logout/?next=${encodeURIComponent(next)}`} {...props} />;
};

LogoutLink.propTypes = {
  ...withRouterPropTypes,
  next: PropTypes.string,
};

export default withRouter(LogoutLink);
